'use client';

import { cn } from '../../lib/utils';
import { useId } from 'react';

/**
 * PlaceholderImage component
 * Displays a placeholder gradient when an image is not available
 */
export interface PlaceholderImageProps {
  className?: string;
  width?: number;
  height?: number;
}

export function PlaceholderImage({ 
  className,
  width = 400,
  height = 225
}: PlaceholderImageProps) {
  const id = useId();
  
  return (
    <svg
      className={cn('w-full h-full', className)}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} fill={`url(#${id})`} />
      <defs>
        <linearGradient
          id={id}
          x1="0"
          y1="0"
          x2={width}
          y2={height}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="hsl(var(--primary) / 0.3)" />
          <stop offset="1" stopColor="hsl(var(--primary) / 0.1)" />
        </linearGradient>
      </defs>
    </svg>
  );
} 